export function writeValidationList(errMsgConfig, fieldValidity) {
  // go over fieldValidity and if true push error of configObj to array return
  // an object in the following style: {negative: true, list: [-arr of labels: and errors-]}
  const msgObj = {
    msgHeader: 'Please check:'
  };
  let errArr = []

  for(let field in fieldValidity) {
    if(!fieldValidity[field])
    errArr.push(`${errMsgConfig[field].label}:   ${errMsgConfig[field].err}`)
  }

  if(errArr.length > 0){
    msgObj.negative = true;
    msgObj.list = errArr;
    return msgObj;
  }
  return {}
};

export const commonFileExtensions = ["aif","ani","api","art","asc","asm","asp",
"avi","bak","bas","bat","bfc","bin","bmp","bud","bz2","c","cat","cbl","cbt",
"cda","cdt","cfml","cgi","chm","lass","clp","cmd","com","cpp","css","csv","cmf","cur",
"dao","dat","dev","dic","dir","dll","doc","dot","drv","dun","dwg","dxf","emf","eml",
"eps","eps2","exe","ffl","ffo","fla","fnt","gif","gid","grp","gz","hex","hlp","ht",
"hqx","htm","html","icl","icm","ico","inf","ini","jar","jpg", "jpeg", "js","lab","lgo",
"lit","lnk","log","lsp","maq","mar","md","mdb","mdl","mid","mod","mov","mp3","mpeg","mpp",
"msg","ncf","nlm","o","ocx","ogg","ost","pak","pcl","pct","pdf","pdr","php","pif","pl","pm","pm3","pm4","pm5","pm6","png","pol","pot","ppd","pps",
"ppt","prn","ps","psd","psp","pst","pub","pwl","qif","ram","rar","raw","reg","rm","rpm","rsc",
"rtf","scr","sea","sgml","sh","sit","smd","svg","swf","swp","sys","tar","tga","tiff",
"tmp","ttf","txt","udf","uue","vbx","vm","vxd","wav","wmf","wsz","xcf","xif","xls",
"xlt","xml","xsl","zip"]



// WEBPACK FOOTER //
// ./src/helper/form-helper.js